export default {
  name: 'workflow',
  translationKey: 'workflow-module',
  routePrefix: 'workflow',
  routeNamePrefix: 'admin.workflow',
  directRoutesAvailable: false,
}
